<template>
  <div id="order-products-preview">
    <v-card>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex
            v-for="(product, index) in differentProducts"
            :key="index"
            xs1
          >
            <v-card height="130px">
              <div v-html="getImage(product)"></div>
              <div class="product-info">
                {{product.position}} ({{product.count}} {{$t('order_products_preview.count')}})
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import Svg from "@/models/Svg.js";
export default {
  name: "order-products-preview",
  props: {
    products: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      differentProducts: [],

    };
  },
  mounted() {
    this.initialize();
  },
  watch: {
    products() {
      this.initialize();
    }
  },
  methods: {
    initialize() {
      let differentProducts = [];
      this.products.forEach(product => {
        const positionFound = differentProducts.find(e => {
          return e.position === product.position;
        });
        if (positionFound) {
          positionFound.count++;
        } else {
          differentProducts.push({
            position: product.position,
            image: product.image,
            count: 1
          });
        }
      });
      this.differentProducts = differentProducts;
    },

    getImage(product) {
      return Svg.fix(product.image, 100, 100);
    }
  }
};
</script>

<style scoped>
.product-info{
  position: absolute;
  bottom: 2px;
  left: 2px;
}
</style>
